module.exports = __webpack_public_path__ + "static/media/removeWatch.2102b42e.svg";